module.exports = __webpack_public_path__ + "media/images/flags/4x3/kos-c6b7d102c29978100544b831ef8d8abb.svg";